var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 15.5A6.5 6.5 0 0 1 5.5 12c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5a6.5 6.5 0 0 1-6.5 6.5z","fill":"#474646","fill-rule":"evenodd"}})
}
var staticRenderFns = []

export { render, staticRenderFns }